// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.features_main {
    display: flex;
    justify-content: center;
}

.features {
    width: 90%;
    /* display: flex;
    justify-content: center; */
}

.feature_h{
    font-size: 0px;
    color: red;
}

.features_heading {
    font-size: 58px;
    font-weight: 700;
    color: #141414;
    font-family: 'Poppins', sans-serif !important;
}
.features_para {
    color: #848484;
    font-size: 24px;
    font-family: 'Poppins', sans-serif !important;
    font-weight: 400;
    margin-bottom: 35px;
}
.features_btn {
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 15px 40px;
    border: 2px solid #E837FF !important;
    color: #7511D3;
    letter-spacing: 1.25px;
    background: transparent;
    font-size: 10px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif !important;  
}


.features_item_main {
    text-align: left;
    margin-bottom: 30px;
    padding: 24px;
    border-radius: 18px;
}

.features_item_main:hover{
    background-color: white;
    border: 0.5px solid #974DD9;
}

.features_item_main_right {
    text-align: left;
    margin-bottom: 30px;
    padding: 24px;
    border-radius: 18px;
}

.features_item_main_right:hover{
    background-color: white;
    border: 0.5px solid #974DD9;
}


.features_item_main h3 {
    display: inline-block; /* Makes h3 an inline-block element */
    font-size: 24px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif !important;
    width: 65px; /* Fixed width for the square */
    height: 65px; /* Fixed height for the square */
    background-color: #F3EAFD; /* Background color white */
    color: #BBBBBB; /* Text color black */
    line-height: 65px; /* Aligns the text vertically */
    text-align: center; /* Aligns the text horizontally */
    border-radius: 10%; /* 10% border radius for slightly rounded corners */
    transition: background-color 0.3s; /* Smooth transition for background color change */
}
.features_item_main_right h3 {
    display: inline-block; /* Makes h3 an inline-block element */
    font-size: 24px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif !important;
    width: 65px; /* Fixed width for the square */
    height: 65px; /* Fixed height for the square */
    background-color: #F3EAFD; /* Background color white */
    color: #BBBBBB; /* Text color black */
    line-height: 65px; /* Aligns the text vertically */
    text-align: center; /* Aligns the text horizontally */
    border-radius: 10%; /* 10% border radius for slightly rounded corners */
    transition: background-color 0.3s; /* Smooth transition for background color change */
}


.features_item_main_right h3:hover {
    background-color: #F3EAFD;
    color: white;
}

.features_item_main h4{
font-family: Sora;
font-size: 20px;
font-weight: 600;
line-height: 28px;
letter-spacing: 0.15000000596046448px;
text-align: left;
    color: #0E121B;

}

.features_item_main_right h4{
    font-family: Sora;
font-size: 20px;
font-weight: 600;
line-height: 28px;
letter-spacing: 0.15000000596046448px;
text-align: left;
    color: #0E121B;

}

.features_item_main p{
font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #7A8089;

}


.features_item_main_right p{
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    text-align: left;
    color: #7A8089;
}

/* .d-flex{
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
} */


.features_img {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    align-items: center;
    background-size: contain; /* Ensures the image covers the entire background */
    background-position: center; /* Centers the image within the container */
    border-radius: 50%;
    height: 70%; /* Adjustable based on design requirement */
    width: 90%; /* Should match height for perfect circle *//* Keeps contents within bounds */
    padding: 15px; /* Adjust padding to ensure rounded corners are visible */
    box-sizing: border-box; /* Ensures padding is included in width/height */
}

.features_img img {
    display: block;
    max-width: 100%; /* Ensures the image does not exceed the content area */
    max-height: 110%; /* Ensures the image does not exceed the content area */
    object-fit: cover; /* Adjusts the fit of the image within the frame, covering the area */
    position: relative;  /* Ensures z-index applies correctly */
    z-index: 10;  /* Higher z-index to ensure it appears on top */
}

.features_item_main.active h3,
.features_item_main_right.active h3 {
    background-color: #F3EAFD;
    color: white; /* Optional, for better visibility */
}





@media (max-width: 768px) {
    .Row {
        display: flex;
        flex-direction: column; /* Stacks columns vertically */
        align-items: center; /* Centers content horizontally in the Row */
        width: 100%; /* Ensures the row takes full width */
    }
    .Col {
        width: 100%; /* Forces column to take the full width of its container */
        display: flex;
        flex-direction: column; /* Ensures content within column is stacked vertically */
        align-items: center; /* Centers content horizontally in the Col */
        justify-content: center; /* Centers content vertically in the Col */
        text-align: center; /* Ensures text alignment is centered */
        margin-top: 20px; /* Adds top margin for spacing */
    }
    .features_heading {
        font-size: 32px; /* Smaller font size for better fit on mobile */
        padding: 0 20px; /* Adds horizontal padding */
    }
    .features_para {
        font-size: 18px; /* Smaller font size for readability on smaller screens */
        padding: 0 20px; /* Adds horizontal padding */
    }
    .features_btn {
        padding: 10px 30px; /* Adjusts padding for a better fit on mobile */
        font-size: 12px; /* Increases font size slightly for better readability */
        margin: 20px 0; /* Adds vertical margin for better spacing */
        width: auto; /* Allows button to size according to its content */
    }
}
`, "",{"version":3,"sources":["webpack://./src/Features/features.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV;8BAC0B;AAC9B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6CAA6C;AACjD;AACA;IACI,cAAc;IACd,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;AACjD;;;AAGA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;;AAGA;IACI,qBAAqB,EAAE,qCAAqC;IAC5D,eAAe;IACf,gBAAgB;IAChB,6CAA6C;IAC7C,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,gCAAgC;IAC9C,yBAAyB,EAAE,2BAA2B;IACtD,cAAc,EAAE,qBAAqB;IACrC,iBAAiB,EAAE,+BAA+B;IAClD,kBAAkB,EAAE,iCAAiC;IACrD,kBAAkB,EAAE,mDAAmD;IACvE,iCAAiC,EAAE,kDAAkD;AACzF;AACA;IACI,qBAAqB,EAAE,qCAAqC;IAC5D,eAAe;IACf,gBAAgB;IAChB,6CAA6C;IAC7C,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,gCAAgC;IAC9C,yBAAyB,EAAE,2BAA2B;IACtD,cAAc,EAAE,qBAAqB;IACrC,iBAAiB,EAAE,+BAA+B;IAClD,kBAAkB,EAAE,iCAAiC;IACrD,kBAAkB,EAAE,mDAAmD;IACvE,iCAAiC,EAAE,kDAAkD;AACzF;;;AAGA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;AACA,iBAAiB;AACjB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;IACZ,cAAc;;AAElB;;AAEA;IACI,iBAAiB;AACrB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;IACZ,cAAc;;AAElB;;AAEA;AACA,kBAAkB;AAClB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;AAChB,cAAc;;AAEd;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;;;;;GAOG;;;AAGH;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB,EAAE,mDAAmD;IAC7E,2BAA2B,EAAE,2CAA2C;IACxE,kBAAkB;IAClB,WAAW,EAAE,2CAA2C;IACxD,UAAU,EAAE,2CAA2C,CAAC,iCAAiC;IACzF,aAAa,EAAE,yDAAyD;IACxE,sBAAsB,EAAE,gDAAgD;AAC5E;;AAEA;IACI,cAAc;IACd,eAAe,EAAE,uDAAuD;IACxE,gBAAgB,EAAE,uDAAuD;IACzE,iBAAiB,EAAE,qEAAqE;IACxF,kBAAkB,GAAG,sCAAsC;IAC3D,WAAW,GAAG,+CAA+C;AACjE;;AAEA;;IAEI,yBAAyB;IACzB,YAAY,EAAE,oCAAoC;AACtD;;;;;;AAMA;IACI;QACI,aAAa;QACb,sBAAsB,EAAE,8BAA8B;QACtD,mBAAmB,EAAE,4CAA4C;QACjE,WAAW,EAAE,qCAAqC;IACtD;IACA;QACI,WAAW,EAAE,0DAA0D;QACvE,aAAa;QACb,sBAAsB,EAAE,wDAAwD;QAChF,mBAAmB,EAAE,4CAA4C;QACjE,uBAAuB,EAAE,0CAA0C;QACnE,kBAAkB,EAAE,uCAAuC;QAC3D,gBAAgB,EAAE,gCAAgC;IACtD;IACA;QACI,eAAe,EAAE,+CAA+C;QAChE,eAAe,EAAE,4BAA4B;IACjD;IACA;QACI,eAAe,EAAE,yDAAyD;QAC1E,eAAe,EAAE,4BAA4B;IACjD;IACA;QACI,kBAAkB,EAAE,+CAA+C;QACnE,eAAe,EAAE,wDAAwD;QACzE,cAAc,EAAE,4CAA4C;QAC5D,WAAW,EAAE,mDAAmD;IACpE;AACJ","sourcesContent":["\n.features_main {\n    display: flex;\n    justify-content: center;\n}\n\n.features {\n    width: 90%;\n    /* display: flex;\n    justify-content: center; */\n}\n\n.feature_h{\n    font-size: 0px;\n    color: red;\n}\n\n.features_heading {\n    font-size: 58px;\n    font-weight: 700;\n    color: #141414;\n    font-family: 'Poppins', sans-serif !important;\n}\n.features_para {\n    color: #848484;\n    font-size: 24px;\n    font-family: 'Poppins', sans-serif !important;\n    font-weight: 400;\n    margin-bottom: 35px;\n}\n.features_btn {\n    margin-right: 20px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding: 15px 40px;\n    border: 2px solid #E837FF !important;\n    color: #7511D3;\n    letter-spacing: 1.25px;\n    background: transparent;\n    font-size: 10px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif !important;  \n}\n\n\n.features_item_main {\n    text-align: left;\n    margin-bottom: 30px;\n    padding: 24px;\n    border-radius: 18px;\n}\n\n.features_item_main:hover{\n    background-color: white;\n    border: 0.5px solid #974DD9;\n}\n\n.features_item_main_right {\n    text-align: left;\n    margin-bottom: 30px;\n    padding: 24px;\n    border-radius: 18px;\n}\n\n.features_item_main_right:hover{\n    background-color: white;\n    border: 0.5px solid #974DD9;\n}\n\n\n.features_item_main h3 {\n    display: inline-block; /* Makes h3 an inline-block element */\n    font-size: 24px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif !important;\n    width: 65px; /* Fixed width for the square */\n    height: 65px; /* Fixed height for the square */\n    background-color: #F3EAFD; /* Background color white */\n    color: #BBBBBB; /* Text color black */\n    line-height: 65px; /* Aligns the text vertically */\n    text-align: center; /* Aligns the text horizontally */\n    border-radius: 10%; /* 10% border radius for slightly rounded corners */\n    transition: background-color 0.3s; /* Smooth transition for background color change */\n}\n.features_item_main_right h3 {\n    display: inline-block; /* Makes h3 an inline-block element */\n    font-size: 24px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif !important;\n    width: 65px; /* Fixed width for the square */\n    height: 65px; /* Fixed height for the square */\n    background-color: #F3EAFD; /* Background color white */\n    color: #BBBBBB; /* Text color black */\n    line-height: 65px; /* Aligns the text vertically */\n    text-align: center; /* Aligns the text horizontally */\n    border-radius: 10%; /* 10% border radius for slightly rounded corners */\n    transition: background-color 0.3s; /* Smooth transition for background color change */\n}\n\n\n.features_item_main_right h3:hover {\n    background-color: #F3EAFD;\n    color: white;\n}\n\n.features_item_main h4{\nfont-family: Sora;\nfont-size: 20px;\nfont-weight: 600;\nline-height: 28px;\nletter-spacing: 0.15000000596046448px;\ntext-align: left;\n    color: #0E121B;\n\n}\n\n.features_item_main_right h4{\n    font-family: Sora;\nfont-size: 20px;\nfont-weight: 600;\nline-height: 28px;\nletter-spacing: 0.15000000596046448px;\ntext-align: left;\n    color: #0E121B;\n\n}\n\n.features_item_main p{\nfont-family: Inter;\nfont-size: 16px;\nfont-weight: 400;\nline-height: 26px;\ntext-align: left;\ncolor: #7A8089;\n\n}\n\n\n.features_item_main_right p{\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    text-align: left;\n    color: #7A8089;\n}\n\n/* .d-flex{\n    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n} */\n\n\n.features_img {\n    display: flex;\n    margin-top: 30px;\n    justify-content: center;\n    align-items: center;\n    background-size: contain; /* Ensures the image covers the entire background */\n    background-position: center; /* Centers the image within the container */\n    border-radius: 50%;\n    height: 70%; /* Adjustable based on design requirement */\n    width: 90%; /* Should match height for perfect circle *//* Keeps contents within bounds */\n    padding: 15px; /* Adjust padding to ensure rounded corners are visible */\n    box-sizing: border-box; /* Ensures padding is included in width/height */\n}\n\n.features_img img {\n    display: block;\n    max-width: 100%; /* Ensures the image does not exceed the content area */\n    max-height: 110%; /* Ensures the image does not exceed the content area */\n    object-fit: cover; /* Adjusts the fit of the image within the frame, covering the area */\n    position: relative;  /* Ensures z-index applies correctly */\n    z-index: 10;  /* Higher z-index to ensure it appears on top */\n}\n\n.features_item_main.active h3,\n.features_item_main_right.active h3 {\n    background-color: #F3EAFD;\n    color: white; /* Optional, for better visibility */\n}\n\n\n\n\n\n@media (max-width: 768px) {\n    .Row {\n        display: flex;\n        flex-direction: column; /* Stacks columns vertically */\n        align-items: center; /* Centers content horizontally in the Row */\n        width: 100%; /* Ensures the row takes full width */\n    }\n    .Col {\n        width: 100%; /* Forces column to take the full width of its container */\n        display: flex;\n        flex-direction: column; /* Ensures content within column is stacked vertically */\n        align-items: center; /* Centers content horizontally in the Col */\n        justify-content: center; /* Centers content vertically in the Col */\n        text-align: center; /* Ensures text alignment is centered */\n        margin-top: 20px; /* Adds top margin for spacing */\n    }\n    .features_heading {\n        font-size: 32px; /* Smaller font size for better fit on mobile */\n        padding: 0 20px; /* Adds horizontal padding */\n    }\n    .features_para {\n        font-size: 18px; /* Smaller font size for readability on smaller screens */\n        padding: 0 20px; /* Adds horizontal padding */\n    }\n    .features_btn {\n        padding: 10px 30px; /* Adjusts padding for a better fit on mobile */\n        font-size: 12px; /* Increases font size slightly for better readability */\n        margin: 20px 0; /* Adds vertical margin for better spacing */\n        width: auto; /* Allows button to size according to its content */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
